import { useQuery } from '@tanstack/react-query';
import { getAllSystemStates } from '../service';
import { AuthQueryFactory } from '../utils/query-factory';

function useSystemStates() {
    const query = useQuery({
        queryKey: AuthQueryFactory.systemStates(),
        queryFn: () => getAllSystemStates(),
    });
    return query;
}

export { useSystemStates };
